import { themeColors } from "../../config.js";

export const explorerStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "white",
  },
  menuBar: {
    display: "flex",
    height: 30,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "stretch",
    fontFamily: "roboto",
    fontSize: 12,
  },
  title: {
    flex: 1,
    width: 60,
    display: "flex",
    padding: 5,
    justifyContent: "flex-start",
    alignItems: "center",
    borderWidth: "1px",
    borderStyle: "solid",
    overflow: "hidden",
    fontSize: 14,
    borderColor: themeColors.borderColor,
    backgroundColor: themeColors.titleColor,
    color: themeColors.titleTextColor,
  },
  menuButton: {
    width: 30,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: themeColors.borderColor,
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
  },
  inputBox: {
    outline: "none",
    margin: "0",
    shadow: "none",
    overflowX: "hidden",
    paddingLeft: 5,
    fontSize: 12,
    fontFamily: "roboto",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: themeColors.borderColor,
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
  },
  entry: {
    padding: 5,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: themeColors.borderColor,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  frame: {
    flex: 1,
    backgroundColor: themeColors.contentColor,
    color: themeColors.contentTextColor,
    fontFamily: "roboto",
    fontSize: 12,
  },
};
